import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import { Badge } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';


function stringToColor(string: string) {
    let hash = 0;
    let i;
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
}

function stringAvatar(name: string) {
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
}

const UserAvatar = (props: any) => {
    return (
        <>
            {
                props.badge ? <Badge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    className="my-1"
                    badgeContent={
                        props.status === 1 ? 
                        <CheckCircleRoundedIcon className='checkText backgroundIcon' fontSize="inherit" /> : props.status === 0 ? <CancelRoundedIcon className='rejectText backgroundIcon' fontSize="inherit" /> : <InfoRoundedIcon className='pendingText backgroundIcon' fontSize="inherit" />
                    }
                >
                    < Avatar key={props.key} {...stringAvatar(props.name)} />
                </Badge> : < Avatar key={props.key} {...stringAvatar(props.name)} />
            }
        </>
    )
}

export default UserAvatar